import { ENV_VALUES } from '../../shared/constants/EnvValues';

import { EnvKeys } from '../../tokens/EnvKeys';

export const isFeatureEnabled = (flagKey: EnvKeys): boolean => {
  const value = ENV_VALUES[flagKey];
  // Handle both string and boolean values
  return (
    value === 'true' ||
    value === '1' ||
    (typeof value === 'boolean' && value === true)
  );
};

// Specific feature flag helpers
export const featureFlags = {
  newLeadForms: () => isFeatureEnabled(EnvKeys.FEATURE_IS_LEAD_FORM),
} as const;
